export default {
    searchTerm: '',
    nowUtc: '',
    ww: '',
    monitoringRemainingTime: window.config.monitoring_remaining_time,
    monitoringChannelsPerPage: window.config.monitoring_channels_per_page,
    entitiesFilter:[],
    universesFilter: [],
    takersFilter: [],
    eventsFilter: [],
};



// WEBPACK FOOTER //
// ./src/store/state.js